"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTourTime = void 0;
var react_1 = __importStar(require("react"));
var strings_1 = __importDefault(require("../strings"));
var ButtonBase_1 = __importDefault(require("@material-ui/core/ButtonBase"));
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var styles_1 = require("@material-ui/core/styles");
var kinsideTokens_1 = require("../kinsideTokens");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    arrowIcon: {
        display: "inline-block",
    },
    card: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        "&:hover": {
            borderWidth: 2,
            background: "rgba(0, 0, 0, 0.04)",
        },
    },
    selectedCard: {
        display: "flex",
        background: theme.palette.grey[400],
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        "&:hover": {
            borderWidth: 2,
            background: theme.palette.grey[500],
        },
    },
    cardAction: {
        textAlign: "left",
        width: "100%",
    },
    labelDate: {
        fontSize: "24px",
        fontWeight: "bold",
    },
    labelDateDisabled: {
        color: theme.palette.grey[300],
        fontSize: "24px",
        fontWeight: "bold",
    },
    labelDayDisabled: {
        color: theme.palette.grey[300],
        fontSize: "14px",
    },
    labelDay: {
        fontSize: "14px",
    },
    labelTime: {
        fontSize: "22px",
        fontWeight: "bold",
    },
    month: {
        textAlign: "center",
        marginBottom: theme.spacing(1),
        fontSize: "18px",
        fontWeight: "bold",
    },
    noTimes: {
        marginTop: theme.spacing(8),
        textAlign: "center",
        fontSize: "20px",
        fontWeight: "bold",
        fontStyle: "italic",
    },
}); });
var SelectTourTime = function (props) {
    var today = function () {
        var d = new Date();
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        return d;
    };
    var classes = useStyles(props);
    var _a = react_1.useState(today()), curDate = _a[0], setCurDate = _a[1];
    var _b = react_1.useState(false), virtualMix = _b[0], setVirtualMix = _b[1];
    var _c = react_1.useState(false), hideWeekends = _c[0], setHideWeekends = _c[1];
    var _d = react_1.useState(), firstStartingDate = _d[0], setFirstStartingDate = _d[1];
    var _e = react_1.useState(), lastStartingDate = _e[0], setLastStartingDate = _e[1];
    var _f = react_1.useState(), selectedCard = _f[0], setSelectedCard = _f[1];
    react_1.useEffect(function () {
        var min;
        var max;
        min = today();
        if (props.availableTimes) {
            setVirtualMix(props.availableTimes.some(function (a) { return a.virtual; }));
            props.availableTimes.forEach(function (a) {
                if (!max || (a.start > max)) {
                    max = a.start;
                }
            });
        }
        else {
            max = new Date(min);
            max.setDate(max.getDate() + 14);
        }
        var hide = false;
        if (!props.showWeekends) {
            hide = true;
            (props.availableTimes || []).forEach(function (a) {
                if ((a.start.getDay() === 6) || (a.start.getDay() === 0)) {
                    hide = false;
                }
            });
        }
        setHideWeekends(hide);
        max = new Date(max.getFullYear(), max.getMonth(), max.getDate());
        if (hide && (max.getDay() < props.daysPerPage)) {
            max.setDate(max.getDate() - 2);
        }
        max.setDate(max.getDate() - props.daysPerPage + 1);
        setFirstStartingDate(min);
        setLastStartingDate(max);
    }, [props.availableTimes, props.showWeekends]);
    var onPrevWeek = function () {
        var d = new Date(curDate);
        d.setDate(d.getDate() - props.daysPerPage);
        if (hideWeekends) {
            if (d.getDay() === 0) {
                d.setDate(d.getDate() - 2);
            }
            else if (d.getDay() === 6) {
                d.setDate(d.getDate() - 1);
            }
            else if (d.getDay() >= curDate.getDay()) {
                d.setDate(d.getDate() - 2);
            }
        }
        if (d < firstStartingDate) {
            d = firstStartingDate;
        }
        setCurDate(d);
    };
    var onNextWeek = function () {
        var d = new Date(curDate);
        d.setDate(d.getDate() + props.daysPerPage);
        if (hideWeekends) {
            if (d.getDay() === 6) {
                d.setDate(d.getDate() + 2);
            }
            else if (d.getDay() === 0) {
                d.setDate(d.getDate() + 1);
            }
            else if (d.getDay() <= curDate.getDay()) {
                d.setDate(d.getDate() + 2);
            }
        }
        if (d > lastStartingDate) {
            d = lastStartingDate;
        }
        setCurDate(d);
    };
    var onClickTour = function (tour) {
        if (selectedCard && (selectedCard.start === tour.start) && (selectedCard.duration === tour.duration) && (selectedCard.virtual === tour.virtual)) {
            setSelectedCard(undefined);
            props.onSelect(undefined, undefined, undefined);
        }
        else {
            setSelectedCard(tour);
            props.onSelect(tour.start, tour.duration, tour.virtual);
        }
    };
    var renderDateHeader = function (offset, disabled) {
        var date = new Date(curDate);
        date.setDate(date.getDate() + offset);
        return (react_1.default.createElement(Card_1.default, null,
            react_1.default.createElement(CardContent_1.default, { style: { paddingBottom: 16 } },
                react_1.default.createElement(Typography_1.default, { align: "center", variant: "subtitle2", className: disabled ? classes.labelDayDisabled : classes.labelDay }, strings_1.default.days[(date.getDay() + 6) % 7].slice(0, 3)),
                react_1.default.createElement(Typography_1.default, { align: "center", variant: "subtitle2", className: disabled ? classes.labelDateDisabled : classes.labelDate }, date.getDate()))));
    };
    var renderTourTime = function (tour) {
        function zeroPad(d) {
            return ("0" + d).slice(-2);
        }
        var hours = tour.start.getHours();
        var minutes = tour.start.getMinutes();
        var isAm = (hours < 12);
        if (hours > 12) {
            hours -= 12;
        }
        else if (hours === 0) {
            hours = 12;
        }
        var selected = selectedCard && (selectedCard.start === tour.start) &&
            (selectedCard.duration === tour.duration) && (selectedCard.virtual === tour.virtual);
        var tip = tour.virtual ? strings_1.default.selectTour.tipVirtual
            : (virtualMix ? strings_1.default.selectTour.tipInPerson : strings_1.default.selectTour.tip);
        return (react_1.default.createElement(ButtonBase_1.default, { className: classes.cardAction, onClick: function () { return onClickTour(tour); } },
            react_1.default.createElement(Tooltip_1.default, { title: tip.replace("{Duration}", tour.duration.toString()) },
                react_1.default.createElement(Grid_1.default, { item: true, xs: true, elevation: 0, className: selected ? classes.selectedCard : classes.card, component: Card_1.default },
                    react_1.default.createElement(CardContent_1.default, { style: { paddingBottom: 16 } },
                        react_1.default.createElement(Grid_1.default, { container: true, direction: "row", alignItems: "center" },
                            react_1.default.createElement(Grid_1.default, { item: true, xs: true },
                                react_1.default.createElement(Typography_1.default, { align: "center", variant: "subtitle2", className: classes.labelTime }, hours + ":" + zeroPad(minutes) + " " + (isAm ? "AM" : "PM"))),
                            tour.virtual && react_1.default.createElement(Grid_1.default, { item: true, xs: 2 },
                                react_1.default.createElement("small", null,
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faComputer })))))))));
    };
    var renderColumn = function (offset) {
        var date = new Date(curDate);
        date.setDate(date.getDate() + offset);
        var tours = props.availableTimes.filter(function (a) {
            return ((a.start.getMonth() === date.getMonth()) && (a.start.getDate() === date.getDate()));
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            renderDateHeader(offset, !tours.length),
            tours.length ? tours.map(function (t) {
                return (react_1.default.createElement(react_1.default.Fragment, null, renderTourTime(t)));
            }) : react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.noTimes }, strings_1.default.selectTour.noTimes)));
    };
    var renderMonth = function (dayOffsets) {
        var monthStr;
        var last = new Date(curDate);
        last.setDate(last.getDate() + dayOffsets[dayOffsets.length - 1]);
        if (last.getMonth() === curDate.getMonth()) {
            monthStr = strings_1.default.chooseDate.months[curDate.getMonth()] + " " + curDate.getFullYear();
        }
        else if (last.getFullYear() === curDate.getFullYear()) {
            monthStr = strings_1.default.chooseDate.months[curDate.getMonth()] + " - " + strings_1.default.chooseDate.months[last.getMonth()] + " " + curDate.getFullYear();
        }
        else {
            monthStr = strings_1.default.chooseDate.months[curDate.getMonth()] + " " + curDate.getFullYear() + " - " + strings_1.default.chooseDate.months[last.getMonth()] + " " + last.getFullYear();
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Divider_1.default, { variant: "fullWidth" }),
            react_1.default.createElement(Grid_1.default, { container: true, spacing: 1, alignItems: "center" },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 10 },
                    react_1.default.createElement(Typography_1.default, { variant: "h2", className: classes.month }, monthStr)),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 1 },
                    react_1.default.createElement(IconButton_1.default, { disabled: curDate <= firstStartingDate, className: classes.arrowIcon, onClick: onPrevWeek },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowLeft, style: {
                                color: curDate <= firstStartingDate ? kinsideTokens_1.kinsideTokens["--gray-20"] : kinsideTokens_1.kinsideTokens["--viridian-50"]
                            } }))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 1 },
                    react_1.default.createElement(IconButton_1.default, { disabled: curDate >= lastStartingDate, className: classes.arrowIcon, onClick: onNextWeek },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowRight, style: {
                                color: curDate >= lastStartingDate ? kinsideTokens_1.kinsideTokens["--gray-20"] : kinsideTokens_1.kinsideTokens["--viridian-50"]
                            } })))),
            react_1.default.createElement(Divider_1.default, { variant: "fullWidth" })));
    };
    if (!props.availableTimes) {
        return null;
    }
    var days = [];
    var idx;
    var dow = curDate.getDay();
    for (idx = 0; days.length < props.daysPerPage; idx++) {
        if (hideWeekends) {
            if (dow === 6) {
                idx += 2;
                dow = 1;
            }
            else if (dow === 0) {
                idx++;
                dow = 1;
            }
            else {
                dow++;
            }
        }
        days.push(idx);
    }
    var spacing = [12, 12, 6, 4, 3, 2, 2, 1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderMonth(days),
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
            (props.daysPerPage === 5) && react_1.default.createElement(Grid_1.default, { item: true, xs: 1 }),
            (props.daysPerPage === 7) && react_1.default.createElement(Grid_1.default, { item: true, xs: 2 }),
            days.map(function (i) {
                return (react_1.default.createElement(Grid_1.default, { item: true, xs: spacing[props.daysPerPage] }, renderColumn(i)));
            }),
            (props.daysPerPage === 5) && react_1.default.createElement(Grid_1.default, { item: true, xs: 1 }),
            (props.daysPerPage === 7) && react_1.default.createElement(Grid_1.default, { item: true, xs: 2 }))));
};
exports.SelectTourTime = SelectTourTime;
exports.SelectTourTime.defaultProps = {
    daysPerPage: 5,
};
